import { useRecordContext, useShowContext } from 'react-admin';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow
} from '@mui/material';
import { useApartmentStates } from '../../../../hooks';
import { ApartmentType } from '../../../../types';

export const TechnicalInfo = () => {
	const record = useRecordContext<ApartmentType>();
	const { record: showRecord } = useShowContext();
	const { getApartmentState } = useApartmentStates();

	if (!record) return null;

	const { state } = record;
	const { document } = showRecord;

	const { name: stateName } = getApartmentState(state) || {};

	return (
		<TableContainer>
			<Table size="small">
				<TableBody>
					<TableRow>
						<TableCell width={280}>Стан</TableCell>
						<TableCell sx={{ fontWeight: 'medium' }}>{stateName}</TableCell>
					</TableRow>
					{document?.length > 0 && (
						<TableRow>
							<TableCell width={280}>Документи</TableCell>
							<TableCell sx={{ fontWeight: 'medium' }}>
								{
									<ul style={{ paddingLeft: 16, margin: 0 }}>
										{document?.map((doc: any, index: number) => (
											<li key={index}>
												<a
													href={doc.src}
													target="_blank"
													rel="noopener noreferrer"
												>
													{doc.title || `Document ${index + 1}`}
												</a>
											</li>
										))}
									</ul>
								}
							</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
